import React, { useEffect, useState } from "react";
import styled from "styled-components";
// Components
import Header from "../components/header/index";
import Cotizador from "../components/cotizador/index";
import Logos from "../components/home/logos";
import Footer from "../components/footer";
// Librerias
import Headroom from "react-headroom";
import BotonFlotante from "../components/home/boton-flotante";
import { useSEO } from "../hooks/useSEO";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--blanco);
  overflow: hidden;
`;

export default function HomeContainer({ data }) {
  // Scroll ni bien carga la página
  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, []);

  // Referidos Header
  const [isReferidosHeaderOpen, setReferidosHeaderOpen] = useState(true);
  const toggleReferidosHeader = () => {
    setReferidosHeaderOpen(!isReferidosHeaderOpen);
  };

  useSEO({
    title: "SeguroMotos: Cotizá tu Seguro de Moto",
    description: "¡Cotizá tu seguro online! Granizo, robo desde 2014, todo riesgo.",
  })

  return (
    <Container>

      {/* Boton Flotante WhatsApp*/}
      <BotonFlotante />

      {/* Canonical */}
      <head>
        <link rel="canonical" href="https://seguromotos.com.ar" />
      </head>
      {/* Header */}
      <Headroom>
        <Header
          isReferidosHeaderOpen={isReferidosHeaderOpen}
          toggleReferidosHeader={toggleReferidosHeader}
        ></Header>
      </Headroom>
      {/* Cotizador */}
      <Cotizador isReferidosHeaderOpen={isReferidosHeaderOpen}></Cotizador>
      {/* Logos */}
      <Logos></Logos>
      {/* Footer */}
      <Footer marcas="active"></Footer>
    </Container>
  );
}
